import { render, staticRenderFns } from "./StudyResultList.vue?vue&type=template&id=667d5a4a&scoped=true&lang=pug"
import script from "./StudyResultList.vue?vue&type=script&lang=ts"
export * from "./StudyResultList.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultList.vue?vue&type=style&index=0&id=667d5a4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d5a4a",
  null
  
)

export default component.exports